const isDevelopment = import.meta.env.VITE_NODE_ENV === 'development';

const config = {
    isDevelopment,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api/v1',

    endpoints: {
        // Auth endpoints
        auth: {
            registerTenant: '/auth/register-tenant',
            login: '/auth/login',
            refresh: '/auth/refresh',
            logout: '/auth/logout',
            acceptInvite: '/auth/accept-invite',
        },

        // User endpoints
        user: {
            me: '/users/me',
            updatePassword: '/users/me/password',
        },

        // Tenant endpoints
        tenant: {
            current: '/tenants/current',
        },

        // Admin endpoints (RBAC Protected)
        admin: {
            // User management
            users: '/admin/users',
            createUser: '/admin/users',
            updateUser: (id) => `/admin/users/${id}`,
            deleteUser: (id) => `/admin/users/${id}`,

            // Tenant management (Super Admin only)
            tenants: '/admin/tenants',
            createTenant: '/admin/tenants',
            updateTenant: (id) => `/admin/tenants/${id}`,
            deleteTenant: (id) => `/admin/tenants/${id}`,

            // Invite management
            invites: '/admin/invites',
            createInvite: '/admin/invites',
            deleteInvite: (id) => `/admin/invites/${id}`,
        },

        // Dashboard endpoints (Tenant-scoped)
        dashboard: {
            metrics: '/dashboard/metrics',
            incidents: '/dashboard/incidents',
            analytics: '/dashboard/analytics',
        },
    },
};

export default config;